<!-- 解决方案 -->
<template>
    <div class="scheme-container">
      <div class="item" v-for="(item,index) in solution" :key="index">
        <h3 class="h3-title"><span>{{item.title}}</span></h3>
        <div class="content-details">
          <div class="content" v-html="item.details"></div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      solution: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {}
  }
</script>

<style lang="scss">
.scheme-container{
  padding: rem(20) rem(20) rem(30);
  .item{
    .h3-title{
      /*height: rem(45);*/
      line-height: rem(24);
      color: #333333;
      font-size: 15px;
      position: relative;
      display: flex;
      align-items: center;
      padding-left: rem(15);
      &:after{
        content: '';
        display: block;
        width: rem(8);
        height: rem(17);
        background: $base-color;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: rem(-8);
      }
    }
    .content-details{
      overflow: hidden;
      line-height: rem(21);
      img{
        width: 100% !important;
        height: auto;
      }
      .content{
        img{
          width: 100% !important;
        }
      }
    }
  }
}
</style>
